import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { batchEditAttribute, cancelBatchAction } from '../../../actions/studio';
import { AppState } from '../../../types/store';
import { getSelectedRowCount } from '../../../selectors/studio';
import { BatchEditAttributeName } from '../../../types/batchActions';
import { Props } from './AttributeBatchEdit';

export type StateProps = Pick<Props, 'selectedCount'>;
export type DispatchProps = Pick<Props, 'cancelBatchAction' | 'onSave'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  selectedCount: getSelectedRowCount(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  onSave: (attrName: BatchEditAttributeName, attrValue: boolean) =>
    dispatch(batchEditAttribute(attrName, attrValue)),
  cancelBatchAction: () => dispatch(cancelBatchAction()),
});

export default connect(mapStateToProps, mapDispatchToProps);
